import router from '@/router'
import config from '@/config/app-cfg'
import axios from 'axios'

export function login (id, mobile, apiKey) {
  // set user id for further transactions
  config.USER_ID = Number(id)
  config.MOBILE_NO = mobile
  localStorage.setItem('USER_ID', id)
  localStorage.setItem('MOBILE_NO', mobile)
  localStorage.setItem('API_KEY', apiKey)
}

export function logout () {
  localStorage.removeItem('USER_ID')
  localStorage.removeItem('MOBILE_NO')
  localStorage.removeItem('SECURITY_POST')
  localStorage.removeItem('API_KEY')
  router.go('/')
}

export function clearCache () {
  localStorage.removeItem('USER_ID')
  localStorage.removeItem('MOBILE_NO')
  localStorage.removeItem('SECURITY_POST')
  localStorage.removeItem('API_KEY')
  localStorage.removeItem('LAST_COMM_ID')
  localStorage.removeItem('WELCOME_COUNTRY_CODE')
  router.push('/')
}

export function isLoggedIn () {
  return new Promise(function (resolve, reject) {
    config.USER_ID = Number(localStorage.getItem('USER_ID'))
    config.MOBILE_NO = localStorage.getItem('MOBILE_NO')
    config.API_KEY = localStorage.getItem('API_KEY') + config.USER_ID

    // check for genuine access
    if (config.USER_ID) {
      var req = {
        user_id: config.USER_ID,
        user_device_id: getUserDevId(),
        api_key: config.API_KEY,
        device_os: 'PWA',
        device_os_ver: navigator.platform,
        device_make: '',
        device_model: '',
        app_ver: config.APP_VER,
        is_web_mob_device: checkForMobDevice() !== ''
      }
      axios.post(config.API_URL + '/authorize-api-key/', req)
      .then(response => {
        resolve(config.USER_ID)
      })
      .catch(err => {
        localStorage.removeItem('USER_ID')
        localStorage.removeItem('MOBILE_NO')
        localStorage.removeItem('API_KEY')
        reject('Access denied:' + err.response.data)
      })
    } else {
      reject('No user info available')
    }
  })
}

export function getUserDevId () {
  return navigator.userAgent.slice(-35)
}

function checkForMobDevice () {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android'
  } else if (navigator.userAgent.match(/iPhone/i)) {
    return 'iPhone'
  } else if (navigator.userAgent.match(/iPad/i)) {
    return 'iPad'
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return 'BlackBerry'
  } else if (navigator.userAgent.match(/Opera Mini/i)) {
    return 'Opera Mini'
  } else if (navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i)) {
    return 'Windows'
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js